import { useRef, useCallback } from "react";
import "./DateSelect.scss";

interface DateSelectProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  required?: boolean;
  disabled?: boolean;
  id?: string;
  className?: string;
  error?: boolean;
}

export default function DateSelect({
  label,
  value,
  onChange,
  min,
  max,
  required,
  disabled,
  id,
  className = "",
  error,
}: DateSelectProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (disabled) return;
    try {
      inputRef.current?.showPicker();
    } catch {
      inputRef.current?.focus();
    }
  };

  const handleFocus = useCallback(() => {
    const close = () => {
      inputRef.current?.blur();
      window.removeEventListener("scroll", close, true);
    };
    window.addEventListener("scroll", close, true);
  }, []);

  return (
    <div
      className={`dateSelect${error ? " hasError" : ""}${className ? ` ${className}` : ""}`}
      onClick={handleClick}
    >
      {label && (
        <span className="dateSelectLabel">
          {label}
          {required && <span style={{ color: "var(--b)", marginLeft: 2 }}>*</span>}
        </span>
      )}
      <input
        ref={inputRef}
        id={id}
        type="date"
        className="dateSelectInput"
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        required={required}
        onFocus={handleFocus}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
